import { BrowserRouter, Routes, Route } from "react-router-dom";

/* Pages */
import MediaGallery from "./pages/MediaGallery";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Implementation from "./pages/Implementation";
import DepartmentDashboard from "./pages/DepartmentDashboard";
import BDODashboard from "./pages/BDODashboard";
import DistrictDashboard from "./pages/DistrictDashboard";
import Schemes from "./pages/Schemes";
/* Admin Pages */
import HealthChildEntry from "./pages/HealthChildEntry";
import DepartmentChildBenefits from "./pages/DepartmentChildBenefits";

import AdminDashboard from "./pages/admin/AdminDashboard";
import ManageBlocks from "./pages/admin/ManageBlocks";
import ManageDepartments from "./pages/admin/ManageDepartments";
import ManageSchemes from "./pages/admin/ManageSchemes";
import ManageUsers from "./pages/admin/ManageUsers";
import Footer from "./components/Footer";
/* Protected Route */

import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/schemes" element={<Schemes />} />
        <Route path="/implementation" element={<Implementation/>}/>
        <Route path="/gallery" element={<MediaGallery />} />
        <Route path="/health-entry" element={<HealthChildEntry />} />
        <Route path="/department-benefits" element={<DepartmentChildBenefits />} />
        
        {/* Department */}
        <Route
          path="/department-entry"
          element={
            <ProtectedRoute allowedRole="department">
              <DepartmentDashboard />
            </ProtectedRoute>
          }
        />

        {/* BDO */}

        <Route
          path="/bdo"
          element={
            <ProtectedRoute allowedRole="bdo">
              <BDODashboard />
            </ProtectedRoute>
          }
        />

        {/* District Dashboard */}

        <Route
          path="/district"
          element={
            <ProtectedRoute allowedRole="district_admin">
              <DistrictDashboard />
            </ProtectedRoute>
          }
        />

        {/* Admin Pages */}

        <Route
          path="/admin"
          element={
            <ProtectedRoute allowedRole="district_admin">
              <AdminDashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/blocks"
          element={
            <ProtectedRoute allowedRole="district_admin">
              <ManageBlocks />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/departments"
          element={
            <ProtectedRoute allowedRole="district_admin">
              <ManageDepartments />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/schemes"
          element={
            <ProtectedRoute allowedRole="district_admin">
              <ManageSchemes />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/users"
          element={
            <ProtectedRoute allowedRole="district_admin">
              <ManageUsers />
            </ProtectedRoute>
          }
        />
      </Routes>
      <Footer/>
    </BrowserRouter>
  );
}

export default App;
